"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ToggleContainer = exports.CloseOnClickOutside = exports.AnimatedToggleContent = void 0;
var react_1 = __importDefault(require("react"));
var animations_1 = require("../../animations");
var Container_1 = require("../Container/Container");
var ToggleContext_1 = require("./ToggleContext");
var AnimatedToggleContent = function (rest) {
    var opened = ToggleContext_1.useToggleContext().opened;
    return react_1["default"].createElement(animations_1.CollapseAnimation, __assign({ collapsed: opened }, rest));
};
exports.AnimatedToggleContent = AnimatedToggleContent;
var CloseOnClickOutside = function (rest) {
    var _a = ToggleContext_1.useToggleContext(), opened = _a.opened, toggleOpen = _a.toggleOpen;
    return opened ? (react_1["default"].createElement(Container_1.Container, __assign({ onClick: function () { return toggleOpen(false); } }, rest))) : null;
};
exports.CloseOnClickOutside = CloseOnClickOutside;
var ToggleContainerContent = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    var opened = ToggleContext_1.useToggleContext().opened;
    return (react_1["default"].createElement(Container_1.Container, __assign({ className: ['toggle-container', opened && 'opened', className] }, rest), children));
};
var ToggleContainer = function (_a) {
    var opened = _a.opened, className = _a.className, ariaId = _a.ariaId, children = _a.children, onChange = _a.onChange, onChanging = _a.onChanging, rest = __rest(_a, ["opened", "className", "ariaId", "children", "onChange", "onChanging"]);
    return (react_1["default"].createElement(ToggleContext_1.ToggleProvider, { opened: !!opened, ariaId: ariaId, onChange: onChange, onChanging: onChanging },
        react_1["default"].createElement(ToggleContainerContent, __assign({ className: className }, rest), children)));
};
exports.ToggleContainer = ToggleContainer;
//# sourceMappingURL=ToggleContainer.js.map